import { HTMLAttributes } from 'react';
import { IconElement } from '../common';

export type VerticalTabsIconItemProps<TabId extends string | number = number> =
  {
    /** Identifier to help identify the current selected tab */
    id?: TabId;
    /** Data attribute for testing purposes */
    dataHook?: string;
    /** Controls focus relative order */
    tabIndex?: number;
    /** Specifies whether the item is disabled */
    disabled?: boolean;
    /** Used for connecting tab panel to the tab item. */
    ['aria-controls']?: HTMLAttributes<HTMLElement>['aria-controls'];
    /** Used for providing context to screen-readers */
    ['aria-label']?: string;
    /** Children - should be <code>Icon</code> */
    children?: IconElement;
  };
